import LightRays from "../../components/ui/LightRays/light-rays";
import Threads from "../../components/ui/Threads/threads";
import Footer from "./layout/footer";
import Header from "./layout/header";

type MainLayoutProps = {
	children: React.ReactNode;
};

const MainLayout = (props: MainLayoutProps) => {
	const { children } = props;

	return (
		<div className="relative" >
			<div
				style={{
					width: "100%",
					height: "600px",
					position: "absolute",
					backgroundColor: 'transparent',
					top: 0,
					left: 0,
					zIndex: -10,
				}}
			>
				<LightRays
					raysOrigin="top-center"
					raysColor="#fff"

					raysSpeed={1.5}
					lightSpread={0.8}
					rayLength={1.2}
					followMouse={true}
					mouseInfluence={0.1}
					noiseAmount={0.1}
					distortion={0.05}
					className="custom-rays absolute left-1/2 top-0 -z-10 -translate-x-1/2"
				/>
			</div>
			<Header />
			<main
				id="skip-nav"
				className="mx-auto mb-16 w-full max-w-5xl flex-1 px-4 py-24 sm:px-8"
			>
				{children}
			</main>
			<Footer />
			{/*<Image
				width={1512}
				height={550}
				className=""
				src="/images/gradient-background-top.png"
				alt=""
				role="presentation"
				priority
			/>*/}
			{/*<Image
				width={1512}
				height={447}
				className="absolute -bottom-6 left-1/2 -z-10 -translate-x-1/2"
				src="/images/gradient-background-bottom.png"
				alt=""
				role="presentation"
				priority
			/>*/}
		</div>
	);
};

export default MainLayout;
